/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface ApproveRejectRecourseBooking$Params {
  recourseBookingId: number;
  approve: boolean;
  rejectComment?: string;
}

export function approveRejectRecourseBooking(
  http: HttpClient,
  rootUrl: string,
  params: ApproveRejectRecourseBooking$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, approveRejectRecourseBooking.PATH, 'patch');
  if (params) {
    rb.path('recourseBookingId', params.recourseBookingId, {});
    rb.query('approve', params.approve, {});
    rb.query('rejectComment', params.rejectComment, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

approveRejectRecourseBooking.PATH = '/service/v1/recoursebooking/approve/{recourseBookingId}';
